export function convertData(data: any): object[] {
  const returnValue: object[] = [];
  for (const [key, value] of Object.entries(data)) {
    if (Object.keys(value as object).includes('id'))
      returnValue.push({ ...(value as object) });
    else returnValue.push({ ...(value as object), id: key });
  }
  return returnValue;
}
